import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Heart, Shield, Users, MapPin } from 'lucide-react';
import { Button } from '../components/Button';
export function About() {
  return <div className="pt-10" data-id="element-161">
      {/* Hero */}
      <section className="bg-white py-20" data-id="element-162">
        <div className="container-custom" data-id="element-163">
          <div className="max-w-3xl mx-auto text-center" data-id="element-164">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-165">
              About Brixen Consulting
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-166">
              We are a premier corporate services provider based in Dubai
              Silicon Oasis, dedicated to simplifying business setup and
              management for entrepreneurs and enterprises.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-20 bg-gray-50" data-id="element-167">
        <div className="container-custom" data-id="element-168">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-169">
            <div data-id="element-170">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-171">
                Our Mission
              </h2>
              <p className="text-gray-600 text-lg mb-6" data-id="element-172">
                To empower businesses with the structural foundation they need
                to thrive in the UAE. We believe that setting up a company
                should be transparent, efficient, and strategically sound.
              </p>
              <p className="text-gray-600 text-lg" data-id="element-173">
                We bridge the gap between complex regulations and business
                goals, acting as your trusted partner on the ground.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6" data-id="element-174">
              {[{
              icon: Shield,
              title: 'Integrity',
              desc: 'Honest advice, always.'
            }, {
              icon: Target,
              title: 'Excellence',
              desc: 'High standards in execution.'
            }, {
              icon: Users,
              title: 'Partnership',
              desc: 'We grow with you.'
            }, {
              icon: Heart,
              title: 'Transparency',
              desc: 'No hidden costs.'
            }].map((val, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-175">
                  <val.icon className="h-8 w-8 text-blue-800 mb-4" data-id="element-176" />
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-177">{val.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-178">{val.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Operating Model */}
      <section className="py-20 bg-white" data-id="element-179">
        <div className="container-custom" data-id="element-180">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-181">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-182">
              Our Operating Model
            </h2>
            <p className="text-gray-600" data-id="element-183">
              We combine internal expertise with a vetted network of partners to
              deliver comprehensive solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-184">
            <div className="p-8 border border-gray-100 rounded-xl bg-slate-50" data-id="element-185">
              <div className="text-4xl font-bold text-blue-200 mb-4" data-id="element-186">01</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-187">
                Internal Execution
              </h3>
              <p className="text-gray-600" data-id="element-188">
                Core corporate services, documentation, and compliance
                management handled in-house.
              </p>
            </div>
            <div className="p-8 border border-gray-100 rounded-xl bg-slate-50" data-id="element-189">
              <div className="text-4xl font-bold text-blue-200 mb-4" data-id="element-190">02</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-191">
                Strategic Partners
              </h3>
              <p className="text-gray-600" data-id="element-192">
                Collaboration with top-tier banks, auditors, and legal firms for
                specialized needs.
              </p>
            </div>
            <div className="p-8 border border-gray-100 rounded-xl bg-slate-50" data-id="element-193">
              <div className="text-4xl font-bold text-blue-200 mb-4" data-id="element-194">03</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-195">
                Client Focus
              </h3>
              <p className="text-gray-600" data-id="element-196">
                Dedicated account managers ensuring seamless communication and
                delivery.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Location Advantage */}
      <section className="py-20 bg-blue-900 text-white" data-id="element-197">
        <div className="container-custom" data-id="element-198">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-199">
            <div data-id="element-200">
              <div className="flex items-center mb-6" data-id="element-201">
                <MapPin className="h-6 w-6 text-blue-400 mr-2" data-id="element-202" />
                <span className="text-blue-200 font-semibold tracking-wide uppercase" data-id="element-203">
                  Location Advantage
                </span>
              </div>
              <h2 className="text-3xl font-bold mb-6" data-id="element-204">
                Based in Dubai Silicon Oasis
              </h2>
              <p className="text-blue-100 text-lg mb-6 leading-relaxed" data-id="element-205">
                Our headquarters in DSO-IFZA places us at the heart of Dubai's
                technology and business innovation hub. This strategic location
                allows us to offer competitive Free Zone packages and access to
                a vibrant ecosystem of tech companies and startups.
              </p>
              <Link to="/contact" data-id="element-206">
                <Button className="bg-white text-blue-900 hover:bg-gray-100 border-none" data-id="element-207">
                  Visit Our Office
                </Button>
              </Link>
            </div>
            <div className="relative h-80 rounded-2xl overflow-hidden bg-blue-800 border border-blue-700" data-id="element-208">
              {/* Abstract representation of map/location */}
              <div className="absolute inset-0 opacity-30 bg-[url('https://images.unsplash.com/photo-1512453979798-5ea904ac8489?auto=format&fit=crop&q=80&w=2070')] bg-cover bg-center" data-id="element-209"></div>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-210">
                <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20 text-center" data-id="element-211">
                  <p className="font-bold text-xl" data-id="element-212">IFZA Properties</p>
                  <p className="text-sm text-blue-100" data-id="element-213">Dubai Silicon Oasis</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Compliance Statement */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-214">
        <div className="container-custom max-w-4xl text-center" data-id="element-215">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-216">
            Compliance & Ethics
          </h2>
          <p className="text-gray-600 leading-relaxed" data-id="element-217">
            Brixen Consulting FZCO operates with strict adherence to UAE
            regulations. We are committed to maintaining the highest ethical
            standards in all our business dealings. We conduct thorough KYC
            (Know Your Customer) checks and ensure all our clients comply with
            local laws.
          </p>
        </div>
      </section>
    </div>;
}